import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../components/Breadcrumbs";

import {
  API_URL,
  IMAGE_PATH,
  APP_LOGO,
  APP_PREFIX_PATH,
} from "../config/AppConfig";
import axios from "axios";
import "../assets/css/Home.scss";
import giphy from "../assets/images/giphy.gif";
const Home = () => {
  const token = sessionStorage.getItem("token");
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 16;

  // Fetch products
  const fetchProducts = () => {
    axios
      .get(API_URL + "/get_product_images")
      .then((response) => {
        if (response.data.success) {
          setProducts(response.data.result || []);
        } else {
          console.log("Error fetching products:", response.data.msg);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  // Pagination logic
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = products.slice(
    indexOfFirstProduct,
    indexOfLastProduct
  );
  const totalPages = Math.ceil(products.length / productsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const breadcrumbItems = [
    {
      label: "Home / ",
      path: token ? `/${APP_PREFIX_PATH}/` : `/${APP_PREFIX_PATH}/login`,
    },
    {
      label: "All Product",
      path: token ? `/${APP_PREFIX_PATH}/` : `/${APP_PREFIX_PATH}/login`,
    },
  ];

  if (loading) {
    return (
      <div className="container mt-5 text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3">Loading products...</p>
      </div>
    );
  }

  return (
    <div className="Home-page d-flex flex-column min-vh-100">
      <div className="container mt-4 flex-grow-1">
        <Breadcrumbs title="All Product" items={breadcrumbItems} />
        {products.length === 0 ? (
          <div className="text-center my-5">
            <img
              src={giphy} // path to your GIF
              alt="No Products"
              style={{ width: "200px", height: "200px" }}
            />
            <p className="mt-3">No products available</p>
          </div>
        ) : (
          <>
            <div
              className="row"
              onClick={() => {
                if (!token) navigate(`/${APP_PREFIX_PATH}/login`);
              }}
            >
              {currentProducts.map((product) => (
                <div
                  className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4"
                  key={product.product_image_id}
                >
                  <div className="product-card">
                    <img
                      src={`${IMAGE_PATH}${product.image}`}
                      alt={product.product_name}
                      className="product-image"
                      style={{
                        width: "100%",
                        height: "250px",
                        objectFit: "cover",
                      }}
                    />
                    {/* <p className="text-center mt-2">{product.product_name}</p> */}
                  </div>
                </div>
              ))}
            </div>

            {/* Pagination */}
            {/* <div className="d-flex justify-content-center mt-4 mb-4">
              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index + 1}
                  onClick={() => handlePageChange(index + 1)}
                  className={`btn mx-1 ${
                    currentPage === index + 1
                      ? "btn-primary"
                      : "btn-outline-primary"
                  }`}
                >
                  {index + 1}
                </button>
              ))}
            </div> */}
          </>
        )}
      </div>

      {/* Footer */}
      <footer className="footer bg-dark text-white py-3">
        <div className="container text-center">
          {/* Logo */}
          <div className="mb-2">
            <img
              src={APP_LOGO}
              alt="TechXChange Logo"
              style={{ width: "120px", maxWidth: "100%" }}
            />
          </div>

          {/* Links */}
          <div className="mb-2">
            <a
              href={token ? `/${APP_PREFIX_PATH}/` : `/${APP_PREFIX_PATH}/login`}
              className="text-white mx-2 footer-link"
            >
              Home
            </a>
            <a
              href={token ? `/${APP_PREFIX_PATH}/` : `/${APP_PREFIX_PATH}/login`}
              className="text-white mx-2 footer-link"
            >
              Products
            </a>
            <a
              href={token ? `/${APP_PREFIX_PATH}/` : `/${APP_PREFIX_PATH}/login`}
              className="text-white mx-2 footer-link"
            >
              Contact
            </a>
          </div>

          {/* Copyright */}
          <p style={{ fontSize: "12px", marginBottom: "0", opacity: 0.8 }}>
            &copy; {new Date().getFullYear()} <strong>@blackcube.ae</strong>.
            All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Home;
